import React, { Component } from 'react';
import './App.css';
var FontAwesome = require('react-fontawesome');

class App extends Component {
  componentDidMount() {
  }
  render() {
    return (
      <div className="App">
        <div className="left">
          <div className="name">
            <p className="App-title" >Liyun Xiu</p>
            <span className="icons">
              <Icon url="mailto:chishui2@gmail.com" name="at" />
              <Icon url="https://github.com/chishui" name="github" />
              <Icon url="https://www.instagram.com/xiuliyun" name="instagram" />
            </span>
          </div>
        </div>
        <div className="right">
          <p className="App-intro">
            I'm a <br />software engineer<br />living in Bay Area.
          </p>
        </div>
      </div>
    );
  }
}

class Icon extends Component {
  render() {
    return (
      <div className="icon" > 
        <a href={this.props.url}>
          <FontAwesome name={this.props.name} size='2x' style={{color: '#bbb', margin: '10px'}}/>
        </a>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js